import {
  IScribeLease,
  IStaffer,
  SCRIBE_LEASE_DOC_ID,
  StafferCollection,
} from '@principle-theorem/principle-core/interfaces';
import {
  CollectionReference,
  DocumentReference,
  IReffable,
  doc,
  subCollection,
} from '@principle-theorem/shared';

/**
 * Resolves a staffer's single-session scribe lease. The lease lives in a
 * staffer subcollection under a well-known doc id so a session can claim it in
 * a transaction without querying; the claim/release logic lives on
 * `ScribeSession`, which owns the session lifecycle the lease guards.
 */
export class ScribeLease {
  /** The staffer's `scribeLease` subcollection. */
  static col(staffer: IReffable<IStaffer>): CollectionReference<IScribeLease> {
    return subCollection<IScribeLease>(
      staffer.ref,
      StafferCollection.ScribeLease
    );
  }

  /**
   * The staffer's one lease doc at the well-known {@link SCRIBE_LEASE_DOC_ID}.
   */
  static doc(staffer: IReffable<IStaffer>): DocumentReference<IScribeLease> {
    // Must be the free `doc(colRef, id)` function, NOT `Firestore.doc`. The
    // browser runs the modular Firestore SDK, whose CollectionReference has no
    // `.doc()` method — `Firestore.doc` calls `collection.doc(id)`, which only
    // exists on the namespaced/admin SDK (Node/tests), so it throws
    // "collection.doc is not a function" at runtime in the app.
    return doc(ScribeLease.col(staffer), SCRIBE_LEASE_DOC_ID);
  }
}
